// GENERATED FILE — do not edit.
// Written by src/scripts/gen-version.js from the root package.json.
export const APP_VERSION = "1.5.0";
